import React from 'react';
import { Link } from 'react-router-dom';
import './Header.css';
import icon from '../../assets/images/icon.png';

const Header: React.FC = () => {
  return (
    <header className="ainstein-header">
      <div className="container">
        <Link to="/ainstein" className="logo">
          <img 
            src={icon} 
            alt="AInstein Icon" 
            className="logo-icon"
            width={32}
            height={32}
          />
          <span>AInstein</span>
        </Link>
      </div>
    </header>
  );
};

export default Header;
